import { render, staticRenderFns } from "./AiotPlatform.vue?vue&type=template&id=2e417f06&scoped=true"
import script from "./AiotPlatform.vue?vue&type=script&lang=js"
export * from "./AiotPlatform.vue?vue&type=script&lang=js"
import style0 from "./AiotPlatform.vue?vue&type=style&index=0&id=2e417f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e417f06",
  null
  
)

export default component.exports